import { gameManagement } from "./pages/game-management";
import { lobbyManagement } from "./pages/lobby-management";
import { playerManagement } from "./pages/player-management";
import { signIn } from "./pages/sign-in";
import { tableManagement } from "./pages/table-management";
import { tenantManagement } from "./pages/tenant-management";
import { transactionManagement } from "./pages/transaction-management";
import { userManagement } from "./pages/user-management";

// components
import { selects } from "./components/selects";

export default {
  root: {
    delete_confirmation_title: "Bu öğeyi silmek istediğinizden emin misiniz?",
    delete_confirmation_message: "Bu öğeyi silmek istediğinizden emin misiniz?",
    delete_success: "Öğe başarıyla silindi",
    delete_error: "Öğe silinirken hata oluştu",
    confirm: "Onayla",
    cancel: "İptal",
    edit_button: "Veriyi Düzenle",
    delete_button: "Sil",
    save_button: "Kaydet",
    go_back_button: "Geri Dön",
    next_button: "Sonraki",
    refresh_button: "Yenile",
    add_button: "Öğe Ekle",
    actions_button: "Eylemler",
    details: "Detaylar",
    online_view: "Çevrimiçi Görünüm",
    show_transaction: "Geçmiş",
    transactions: "Geçmiş",
    yes: "Evet",
    no: "Hayır",
    copy_success: "Panoya kopyalandı",
    copy_button: "Kopyala",
    empty: "Boş",
    search: "Ara",
    won: "Kazandı !",
  },
  sidebar: {
    logout: "Çıkış Yap",
    search_input_placeholder: "Ara...",
    menu: {
      home: "Ana Sayfa",
      dashboard: "Gösterge Paneli",
      "table-management": "Masa Listesi",
      "game-management": "Oyun Geçmişi",
      "transaction-management": "Geçmiş",
      "lobby-management": "Lobi Listesi",
      "user-management": "Admin Listesi",
      "tenant-management": "Tenant Listesi",
      "operator-management": "Operatör Listesi",
      "player-management": "Oyuncu Listesi",
    },
  },
  dashboard: {
    title: "Wisegaming Oyun paneline Hoş Geldiniz {{name}}",
    description: "Bu oyun paneli sayfasıdır. Sol taraftan bir menü seçebilirsiniz.",
  },
  ...lobbyManagement,
  ...tableManagement,
  ...gameManagement,
  ...tenantManagement,
  ...userManagement,
  ...playerManagement,
  ...transactionManagement,
  ...signIn,
  // components
  ...selects,
};
